import { getProducts, ProductFilter } from '@ttstr/api';
import { ThunkActionCreator } from '.';

export const TICKETS_REQUESTED = 'TICKETS.TICKETS_REQUESTED';
export const TICKETS_RECEIVED = 'TICKETS.TICKETS_RECEIVED';
export const TICKETS_RECEIVE_FAILED = 'TICKETS.TICKETS_RECEIVE_FAILED';
export const TICKETS_RECEIVE_DONE = 'TICKETS.TICKETS_RECEIVE_DONE';

export const receiveTickets: ThunkActionCreator = (filter?: ProductFilter) => async (dispatch) => {
  dispatch({
    type: TICKETS_REQUESTED,
  });

  try {
    const tickets = await getProducts(Object.assign({ type: 'Ticket' }, filter));
    dispatch({
      type: TICKETS_RECEIVED,
      payload: {
        tickets,
      },
    });
  } catch (error) {
    dispatch({
      type: TICKETS_RECEIVE_FAILED,
      payload: {
        error,
      },
    });
  } finally {
    dispatch({
      type: TICKETS_RECEIVE_DONE,
    });
  }
};
